import { IOfferSpendListTableLang } from '../../../types/lang'

export const offerSpendListTableLang: IOfferSpendListTableLang = {
	offer_spend_list_table: {
		column_id: 'ID_ru',
		column_date: 'Date_ru',
		column_date_updated: 'Date Updated_ru',
		column_amount: 'Amount_ru',
		column_account_id: 'Account ID_ru',
		column_account: 'Account_ru',
		column_account_in_group: 'Account in Group_ru',
		column_kt_group: 'KT Group_ru',
		column_offer_id: 'Offer ID_ru',
		column_offer: 'Offer_ru',
		column_scope_id: 'Scope ID_ru',
		column_scope: 'Scope_ru',
		column_history: 'History_ru',
		column_notes: 'Notes_ru'
	}
}